import { render } from "./CoreSolutions.vue?vue&type=template&id=76783838&scoped=true"
import script from "./CoreSolutions.vue?vue&type=script&lang=js"
export * from "./CoreSolutions.vue?vue&type=script&lang=js"

import "./CoreSolutions.vue?vue&type=style&index=0&id=76783838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76783838"]])

export default __exports__